import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_cq3bdzqtzm: FaireBrandEntity = {
  token: "b_cq3bdzqtzm",
  type: "brand",
  name: "Upton",
  avatarUrl:
    "https://cdn.faire.com/fastly/11757d4eab2e365219bac5526e4f509ee579e937b01a631db97933c28ae78a01.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/78e6c6e3c184aca6e4f90e908931aac1ddf6bb70d23b1675db68fff9412374f2.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/11757d4eab2e365219bac5526e4f509ee579e937b01a631db97933c28ae78a01.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/78e6c6e3c184aca6e4f90e908931aac1ddf6bb70d23b1675db68fff9412374f2.jpeg",
  location: "Vista, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 7,
  isTopShop: true,
  isInsider: true,
  description:
    "Upton is a Southern California based design studio that creates artwork and goods for the home. Established by husband and wife Michael and Mariel Upton, Upton is founded on the belief that everyone should be able to live with beauty every day. \n\nProducing work that encompasses the intersection of art, design, and life at home, Upton’s pieces are approachable and accessible without sacrificing on quality.\n\nArtist Owned and Operated\n\nAt Upton, we make what we love. Everything we produce is designed in-house by Michael, with thought and attention on the materials and production of each piece. We embrace the handmade and imperfect. We do this because it makes us happy. \n\nWe are passionate about art, design, and life at home. With Upton, we've created a studio that plays within these genres and between multiple mediums, allowing ourselves to create any type of art or object we believe will bring beauty, comfort, and love into the home.",
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:14:09.040Z",
    importedBy: "entity-db-cli",
  },
};
